import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialMdcModule } from 'src/app/shared/material-mdc.module';
import { MutipleFacilityComponent } from './mutiple-facility.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    MutipleFacilityComponent
  ],
  imports: [
    CommonModule,
    MaterialMdcModule,
    ReactiveFormsModule
  ]
})
export class MultipleFacilityModule { }
